// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2Ls7w","row":"Node_row__ZrVwR","label":"Node_label__2djk8","footer":"Node_footer__1pMLU"};